export default {
  idalinhamentotanquefisico: 0,
  idtanquevirtual: '',
  idposto: 0,
  idcliente: 0,
  idusuario: 0,
  idproduto: 0,
  tanques: [],
};
